import { render, staticRenderFns } from "./DeliveryGuide.vue?vue&type=template&id=4b1e8980&scoped=true"
import script from "./DeliveryGuide.vue?vue&type=script&lang=js"
export * from "./DeliveryGuide.vue?vue&type=script&lang=js"
import style0 from "./DeliveryGuide.vue?vue&type=style&index=0&id=4b1e8980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1e8980",
  null
  
)

export default component.exports